export default "__VITE_ASSET__88df9769__"